module.exports = __webpack_public_path__ + "img/Plantas erradicadas 3.44dea6ac.webp";